import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  TextField,
  InputAdornment,
  CircularProgress,
  IconButton,
} from "@mui/material";
import { api } from "../../api/api";
import { country_url, signup_url } from "../../api/urls";
import { MobileNumberDropdown } from "../../components/MobileNumberDropdown";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { Eye, EyeOff } from "lucide-react";
import { getMobileNumberLengthFromRegex } from "../../utils/mobileRegexLength";

const Signup = ({ onClose, setPage, setToken, setIsUnRegistered }) => {
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onSubmit",
  });
  const [loading, setLoading] = useState(false);
  // const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const [countries, setCountries] = useState([]);
  const [isCountriesLoading, setIsCountriesLoading] = useState(true);
  const [defaultCountry, setDefaultCountry] = useState(null);
  const [showPassword, setShowPassword] = useState(true);
  // const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCountryCode, setSelectedCountryCode] = useState("91");
  const [selectedCountry, setSelectedCountry] = useState({
    country_mobile_code: 91,
    country_name: "India",
  });

  // const[referralCode]

  useEffect(() => {
    const fetchCountries = async () => {
      setIsCountriesLoading(true);
      try {
        const { data } = await api.get(country_url);
        setCountries(data);
        const defaultCountryData = data.find(
          (country) => country.country_mobile_code === 91,
        );
        if (defaultCountryData) {
          setDefaultCountry(defaultCountryData);
          setSelectedCountry(defaultCountryData);

          setSelectedCountryCode(defaultCountryData.country_mobile_code);
        }
      } catch (error) {
        toast.error("Failed to fetch country data. Please try again later.");
      } finally {
        setIsCountriesLoading(false);
      }
    };
    fetchCountries();
  }, []);
  useEffect(() => {
    const unsub = watch((value) => {
      const current = value.mobileNumber;
      if (current?.startsWith("0")) {
        setValue("mobileNumber", current.slice(1)); //  remove "0" instantly
      }
    });
    return () => unsub.unsubscribe();
  }, [watch, setValue]);

  const onSubmit = async (data) => {
    setLoading(true);

    if (!selectedCountryCode) {
      toast.error("Please select a country code.");
      setLoading(false);
      return;
    }

    try {
      const requestData = {
        country_code: selectedCountryCode,
        full_name: data.firstName,
        middle_name: data.middleName || "",
        last_name: data.lastName,
        email: data.email,
        mobile_number: `${selectedCountryCode}${data.mobileNumber}`,
        password: data.password,
      };
      // console.log("Signup payload:", requestData);

      const response = await api.post(signup_url, requestData);
      // console.log("Signup payload:", requestData);

      // Check for success status code
      if (response.status === 201 || response.status === 200) {
        const tokenFromResponse = response.data.token; //  adjust if backend sends it like this
        setToken(tokenFromResponse);

        setPage(1); // Move to OTP screen
      } else {
        toast.error("Unexpected response from server.");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.Password_regex ||
        error.response?.data?.data ||
        error.response?.data?.user ||
        "Something went wrong. Please try again.";
      toast.error(errorMessage);
      // console.log(error, "i am error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="auth-card"
      > */}
      {/* <div className="xIcon" onClick={onClose}>
        <X />
      </div> */}
      {/* <button className="xIcon" onClick={onClose} aria-label="Close">
  <X size={24} />
</button> */}
      {/* <div
          className="xIcon"
          onClick={onClose}
          // aria-label="close"
          // sx={{
          //   position: "absolute",
          //   top: 10,
          //   right: 10,
          //   zIndex: 9999,
          //   color: "black", // change if needed
          // }}
        >
          <X size={24} />
        </div> */}

      <h2 style={styles.title}>Sign Up</h2>
      <form onSubmit={handleSubmit(onSubmit)} style={styles.form}>
        <Controller
          name="firstName"
          control={control}
          rules={{
            required: "first name is required",
            pattern: {
              value: /^[A-Za-z\s]+$/, // only letters and spaces
              message: "first name can only contain letters",
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="First name"
              fullWidth
              error={!!errors.firstName}
              helperText={errors.firstName?.message}
              variant="outlined"
              onChange={(e) => {
                const trimmed = e.target.value.replace(/^\s+|\s+$/g, ""); // trim leading/trailing spaces
                field.onChange(trimmed);
              }}
            />
          )}
        />
        <Controller
          name="middleName"
          autoComplete="additional-name"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Middle Name"
              fullWidth
              error={!!errors.middleName}
              helperText={errors.middleName?.message}
              variant="outlined"
              onChange={(e) => {
                const trimmed = e.target.value.replace(/^\s+|\s+$/g, ""); // trim leading/trailing spaces
                field.onChange(trimmed);
              }}
            />
          )}
        />
        <Controller
          name="lastName"
          control={control}
          rules={{
            required: "Last name is required",
            pattern: {
              value: /^[A-Za-z\s]+$/, // only letters and spaces
              message: "last name can only contain letters",
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Last Name"
              fullWidth
              error={!!errors.lastName}
              helperText={errors.lastName?.message}
              variant="outlined"
              onChange={(e) => {
                const trimmed = e.target.value.replace(/^\s+|\s+$/g, ""); // trim leading/trailing spaces
                field.onChange(trimmed);
              }}
            />
          )}
        />
        <Controller
          name="email"
          control={control}
          rules={{
            required: "Email is required",
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: "Enter a valid email",
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Email"
              fullWidth
              error={!!errors.email}
              helperText={errors.email?.message}
              variant="outlined"
            />
          )}
        />
        {/* <Controller
          name="mobileNumber"
          control={control}
          rules={{
            required: "Mobile number is required",
            pattern: {
              value: /^[0-9]{7,15}$/,
              message: "Enter a valid mobile number",
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Phone Number"
               type="tel"
              fullWidth
              name="user_phone"
              autoComplete="tel-national"
              error={!!errors.mobileNumber}
              helperText={errors.mobileNumber?.message}
              variant="outlined"

              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {isCountriesLoading ? (
                      <CircularProgress size={20} />
                    ) : (
                
                      <MobileNumberDropdown
  countryData={countries}
  value={selectedCountryCode}
  onChange={(selectedCountry) => {
    setSelectedCountryCode(selectedCountry.country_mobile_code);
    setValue("mobileNumber", ""); // clear number
    setValue("password", ""); // clear password
  }}
  defaultCountry={defaultCountry}
/>

                    )}
                  </InputAdornment>
                ),
              }}
              inputProps={{
                autoComplete: "tel-national",
              }}
            />
          )}
        /> */}
        <Controller
          name="mobileNumber"
          control={control}
          rules={{
            required: "Mobile number is required",
            // pattern: {
            //   value: /^[0-9]{7,15}$/,
            //   message: "Enter a valid mobile number",
            // },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Phone Number"
              type="tel"
              fullWidth
              name="user_phone"
              autoComplete="tel-national"
              error={!!errors.mobileNumber}
              helperText={errors.mobileNumber?.message}
              variant="outlined"
              onChange={(e) => {
                // keep only digits
                const digitsOnly = e.target.value.replace(/\D/g, "");

                const mobileMaxLength =
                  getMobileNumberLengthFromRegex(
                    selectedCountry?.country_regex,
                    selectedCountryCode.toString(),
                  ) || 11;

                if (digitsOnly.length > mobileMaxLength) return; // block extra digits
                field.onChange(digitsOnly);
              }}
              onPaste={(e) => {
                // block pasting non-digit text
                const pasted = e.clipboardData
                  .getData("text")
                  .replace(/\D/g, "");
                e.preventDefault();
                field.onChange(pasted);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {isCountriesLoading ? (
                      <CircularProgress size={20} />
                    ) : (
                      <MobileNumberDropdown
                        countryData={countries}
                        value={selectedCountryCode}
                        onChange={(selectedCountry) => {
                          setSelectedCountryCode(
                            selectedCountry.country_mobile_code,
                          );
                          setValue("mobileNumber", ""); // clear number
                          setValue("password", ""); // clear password
                        }}
                        defaultCountry={defaultCountry}
                      />
                    )}
                  </InputAdornment>
                ),
              }}
            />
          )}
        />

        <Controller
          name="password"
          control={control}
          rules={{
            required: "Password is required",
            minLength: {
              value: 8,
              message: "Password must be at least 8 characters long",
            },
            pattern: {
              value: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/,
              message:
                "Password must contain at least 1 uppercase letter,  number, and 1 special character",
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Password"
              type={showPassword ? "text" : "password"}
              fullWidth
              error={!!errors.password}
              helperText={errors.password?.message}
              variant="outlined"
              onChange={(e) => {
                const trimmed = e.target.value.replace(/^\s+|\s+$/g, ""); // trim spaces
                field.onChange(trimmed);
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                      size="small"
                      tabIndex={-1}
                    >
                      {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )}
        />

        <motion.button
          type="submit"
          fullWidth
          disabled={loading}
          style={styles.button}
          whileHover={{ scale: 1.05 }}
        >
          {loading ? "Signing Up..." : "Sign Up"}
        </motion.button>
        <motion.div
          type="button"
          onClick={() => setIsUnRegistered(0)}
          whileTap={{ scale: 0.95 }}
          whileHover={{ scale: 1.05 }}
          className="block w-full text-center mt-[2px] py-3 underline underline-offset-2 text-sm cursor-pointer transition-all duration-300 ease-in-out"
        >
          Already have an account? Sign-in
        </motion.div>
      </form>
      {/* </motion.div> */}
    </>
  );
};

const styles = {
  title: {
    textAlign: "center",
    marginBottom: "10px",
    color: "#333",
    fontSize: "24px",
    fontWeight: "bold",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "18px",
  },
  button: {
    background: "#000000",
    color: "#FFF",
    padding: "12px",
    fontSize: "16px",
    borderRadius: "5px",
  },
  signInButton: {
    width: "100%",
    padding: "12px 0",
    marginTop: "2px",
    borderRadius: "8px",
    border: "1px solid #000",
    backgroundColor: "#fff",
    color: "#000",
    fontWeight: 600,
    fontSize: "14px",
    cursor: "pointer",
    transition: "all 0.3s ease-in-out",
  },
};

export default Signup;
